const VERSION_STORAGE_KEY = "transmex_app_version";
const CHECK_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Detecta nuevas publicaciones y recarga la app (sin Ctrl+F5).
 * Requiere version.json generado en build (npm run build).
 */
export function startAppVersionCheck() {
  if (process.env.NODE_ENV !== "production") {
    return () => {};
  }

  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const versionUrl = `${base}/version.json`;

  const check = async () => {
    try {
      const res = await fetch(`${versionUrl}?_=${Date.now()}`, {
        cache: "no-store",
      });
      if (!res.ok) return;

      const data = await res.json();
      const remote = String(data.version ?? "");
      if (!remote) return;

      const stored = localStorage.getItem(VERSION_STORAGE_KEY);
      if (stored && stored !== remote) {
        localStorage.setItem(VERSION_STORAGE_KEY, remote);
        window.location.reload();
        return;
      }
      if (!stored) {
        localStorage.setItem(VERSION_STORAGE_KEY, remote);
      }
    } catch {
      /* version.json ausente o red */
    }
  };

  check();
  const interval = setInterval(check, CHECK_INTERVAL_MS);
  window.addEventListener("focus", check);

  return () => {
    clearInterval(interval);
    window.removeEventListener("focus", check);
  };
}
